export const EMAIL_ALREADY_EXISTS = 'An account with the given email already exists.';
export const EXPIRED_CODE = 'Invalid code provided, please request a code again.';
export const INVALID_USER = 'User does not exist.';
export const INVALID_VERIFICATION_CODE = 'Invalid verification code provided, please try again.';
export const COMPROMISED_PASSWORD = 'Provided password cannot be used for security reasons.';
